import { captureException } from '@repo/error';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { Domain } from '@repo/domain';
import { shouldRetry } from '../queryClient';
import { resolveRepository } from '../registry/resolveRepository';
import { isAxiosTimeout } from '../utils/isAxiosTimeout';
import { isNetworkError } from '../utils/isNetworkError';
const TIMEOUT_MAX_RETRIES = 2;
const partialParkingKeys = {
    all: ['partialParkings'],
    get: (filter) => ['partialParkings', filter],
};
export const partialParkingOptions = {
    get: (filter) => queryOptions({
        queryKey: partialParkingKeys.get(filter),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.PartialParking);
            return repo.get(filter);
        },
        placeholderData: keepPreviousData,
        retry: (failureCount, error) => {
            if (isAxiosTimeout(error)) {
                const willRetry = failureCount < TIMEOUT_MAX_RETRIES;
                if (!willRetry) {
                    captureException(error, { tags: { domain: 'partialParking', source: 'typesense' } });
                }
                return willRetry;
            }
            return shouldRetry(failureCount, error);
        },
        throwOnError: (error) => {
            if (isAxiosTimeout(error))
                return false;
            return isNetworkError(error);
        },
    }),
};
